/* tslint:disable */

/* eslint-disable */

/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// May contain unused imports in some cases
// @ts-ignore
import { DefaultGameLimit } from "./default-game-limit";
// May contain unused imports in some cases
// @ts-ignore
import { FillingRule } from "./filling-rule";
// May contain unused imports in some cases
// @ts-ignore
import { Player } from "./player";
// May contain unused imports in some cases
// @ts-ignore
import { Rule } from "./rule";

/**
 *
 * @export
 * @interface BoardingTable
 */
export interface BoardingTable {
  /**
   *
   * @type {string}
   * @memberof BoardingTable
   */
  aid: string;
  /**
   *
   * @type {string}
   * @memberof BoardingTable
   */
  boarding_mode: BoardingTableBoardingModeEnum;
  /**
   *
   * @type {string}
   * @memberof BoardingTable
   */
  cid: string;
  /**
   *
   * @type {DefaultGameLimit}
   * @memberof BoardingTable
   */
  default_rule?: DefaultGameLimit;
  /**
   *
   * @type {FillingRule}
   * @memberof BoardingTable
   */
  filling_rule: FillingRule;
  /**
   *
   * @type {string}
   * @memberof BoardingTable
   */
  game_group: string;
  /**
   *
   * @type {string}
   * @memberof BoardingTable
   */
  game_type: string;
  /**
   *
   * @type {number}
   * @memberof BoardingTable
   */
  last_boarding_timestamp: number;
  /**
   *
   * @type {number}
   * @memberof BoardingTable
   */
  last_exit_time: number;
  /**
   *
   * @type {number}
   * @memberof BoardingTable
   */
  last_game_with_opponents_timestamp: number;
  /**
   *
   * @type {number}
   * @memberof BoardingTable
   */
  limit: number;
  /**
   *
   * @type {number}
   * @memberof BoardingTable
   */
  min_hands_after_allin: number;
  /**
   *
   * @type {number}
   * @memberof BoardingTable
   */
  min_hands_at_profit: number;
  /**
   *
   * @type {Array<Player>}
   * @memberof BoardingTable
   */
  players?: Array<Player>;
  /**
   *
   * @type {string}
   * @memberof BoardingTable
   */
  room: string;
  /**
   *
   * @type {Rule}
   * @memberof BoardingTable
   */
  rule?: Rule;
  /**
   *
   * @type {number}
   * @memberof BoardingTable
   */
  table_left_time_limit: number;
  /**
   *
   * @type {string}
   * @memberof BoardingTable
   */
  tid: string;
}

export const BoardingTableBoardingModeEnum = {
  Default: "DEFAULT",
  Free: "FREE",
  Semi: "SEMI",
  Auto: "AUTO",
} as const;

export type BoardingTableBoardingModeEnum =
  (typeof BoardingTableBoardingModeEnum)[keyof typeof BoardingTableBoardingModeEnum];
